<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.specialties', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="card">
                    <div class="card-body p-1em">
                        <h3 class="card-title text-center mb-0">
                            {{ mSpecialty.name }}
                        </h3>
                    </div>
                    <b-container>
                        <div class="list-group list-group-flush">
                            <b-row>
                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $t('message.name') }}:

                                        <span class="font-weight-bold">
                                {{ mSpecialty.name }}
                            </span>
                                    </div>
                                </b-col>
                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $tc('message.professions', 1) }}:

                                        <span class="font-weight-bold">
                                {{ mSpecialty.profession.name }}
                            </span>
                                    </div>
                                </b-col>
                            </b-row>

                            <b-row class="justify-content-sm-center" v-if="can">
                                <div class="card-footer text-right">
                                    <b-button variant="primary" @click="updateSpecialty">
                                        {{ $t('message.edit') }}
                                    </b-button>

                                    <b-button v-b-modal.delete-modal variant="danger">
                                        {{ $t('message.delete') }}
                                    </b-button>
                                </div>
                            </b-row>
                        </div>
                    </b-container>




                    <b-modal
                            id="delete-modal"
                            size="sm"
                            header-bg-variant="danger"
                            header-text-variant="light"
                            :title="$t('message.delete') + ' ' + $tc('message.specialties', 1)"
                            hide-footer
                    >
                        <div class="d-block text-center">
                            <h3>{{ $t('message.delete') }} {{ mSpecialty.name }}?</h3>
                        </div>

                        <div class="d-block float-right">
                            <b-button variant="danger" @click="deleteSpecialty">
                                {{ $t('message.delete') }}
                            </b-button>

                            <b-button variant="secondary" @click="$bvModal.hide('delete-modal')">
                                {{ $t('message.cancel') }}
                            </b-button>
                        </div>
                    </b-modal>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';

    export default {
        name: "Specialty",

        computed: {
            ...mapGetters(["specialty",'hasAdminRole',
                'hasGestionnaireRole']),

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole;
            },

            mSpecialty: function() {
                return this.specialty;
            }
        },

        data() {
            return {
                specialty_id: this.$route.params.specialty
            }
        },

        methods: {
            getSpecialty() {
                let args = {
                    specialty: this.specialty_id
                };

                this.$store.dispatch("getSpecialty", { args });
            },

            formattedDate(date) {
                return moment(date).format('DD-MM-YYYY HH:mm');
            },

            updateSpecialty() {
                this.$router.push({ name: 'edit-specialty', params: { specialty: this.specialty_id } });
            },

            deleteSpecialty() {
                let self = this;
                let args = {
                    specialty: this.specialty_id
                };

                let successMessage = this.$i18n.t('message.specialtyDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteSpecialty', { args, index: self.specialty_id, successMessage, errorMessages }).then(() => {
                    self.$bvModal.hide('delete-modal');
                    this.$router.back();

                });
            }
        },

        mounted() {
            this.getSpecialty();
        }
    }
</script>

<style scoped>

</style>